/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PayBookingPayload = {
    type: PayBookingPayload.type;
};
export namespace PayBookingPayload {
    export enum type {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

